import { type MouseEventHandler, PureComponent } from "react";
import { Blue7 } from "styles/antTheme/Colors";

import "./ColorSwatch.less";

interface IColorSwatchProps {
    className: string;
    color: string;
    size: number;
    selected?: boolean;
    onClick: (color: string) => void;
    pointer?: boolean;
    testId?: string;
    onMouseDown?: MouseEventHandler<HTMLSpanElement>;
}

export class ColorSwatch extends PureComponent<IColorSwatchProps> {
    static readonly defaultProps = {
        className: "",
        selected: false,
        onClick: () => {},
        pointer: false,
        size: 28,
    };

    private readonly handleSwatchClick = () => {
        const { onClick, color } = this.props;
        onClick(color);
    };

    render() {
        const { color, selected, pointer, className, testId, onMouseDown } = this.props;
        const borderColor = selected ? Blue7 : "transparent";
        const cursor = pointer ? "pointer" : "default";

        return (
            <div className={`ColorSwatch-Container ${className}`}>
                <span
                    className="ColorSwatch-Outline"
                    style={{
                        width: `${this.props.size + 8}px`,
                        height: `${this.props.size + 8}px`,
                        borderColor: borderColor,
                    }}
                >
                    <span
                        className="ColorSwatch-Swatch"
                        data-testid={testId}
                        aria-label={`Color ${color}`}
                        aria-pressed={selected}
                        style={{
                            background: color,
                            width: this.props.size,
                            height: this.props.size,
                            cursor: cursor,
                        }}
                        onClick={this.handleSwatchClick}
                        onMouseDown={onMouseDown}
                    />
                </span>
            </div>
        );
    }
}
